<template>
  <mdb-container class="gp-has-header text-left">
    <h3>Tenant Static Site URL Redirectors</h3>
    <mdb-btn @click="addRow" size="sm">Add Row</mdb-btn>
    <div ref="table"></div>
    <yes-no-modal @yes="doDelete" @no="deleteModal=false" v-if="deleteModal"/>

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {TabulatorFull as Tabulator} from 'tabulator-tables';
import yesNoModal from "../common/YesNoModal";
import {mdbBtn, mdbContainer} from "mdbvue";


export default {
  name: "tenant-redirector",
  display: "Tenant Redirector",
  order: 1,
  components: {
    mdbContainer, mdbBtn, yesNoModal
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    }
  },
  data() {
    return {
      tabulator: null,
      tableData: [],
      deleteCandidate: null,
      deleteModal: false
    }
  },
  mounted() {
    this.$store.dispatch("setExecuting", true)
    api.get("/admin/tenantRedirectors").then(
      (details) => {
        this.tableData = details.data
        this.tabulator = new Tabulator(this.$refs.table, {
          data: this.tableData,
          reactiveData: true,
          height: "75%",
          layout:"fitColumns",
          columns: [
            {title: "ID", field: "id", visible: false },
            {title: "URL", field: "url", sorter: "string", editor: "input", width: 600, cellEdited:  (cell) =>  {
                this.cellChanged(cell)}
            },
            {title: "Redirects to Tenant Id", field: "tenantId", sorter: "string", editor: "number",
              editorParams: {min: 1, max: 999999999},
              cellEdited:  (cell) =>  {
                this.cellChanged(cell)}
            },
            {title: "Tenant Name", field: "tenantName"},
            {width: "50", formatter:"buttonCross", cellClick: (e,cell) => {
                  this.deleteCell(e,cell)
              }
            }
          ]
        })
      },
      (error) => {

      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })


  },
  methods: {
    deleteCell(e,cell) {
      if (! cell.getRow().getData().id) {
        cell.getRow().delete()
        return
      }
      this.deleteCandidate = cell
      this.deleteModal = true
    },
    doDelete() {
      this.deleteModal = false
      this.$store.dispatch("setExecuting",true)
      api.delete("/admin/tenantRedirectors/" + this.deleteCandidate.getRow().getData().id).then(
        (details) => {
          this.deleteCandidate.getRow().delete()
          this.$notify.success({message: "Deleted", timeOut: 2000})
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    addRow() {
      this.tabulator.addData([{id: null, url:"", tenantId: null, tenantName: ""}], true)
        .then(function(rows){
          //rows - array of the row components for the rows updated or added

          //run code after data has been updated
        })
        .catch(function(error){
          //handle error updating data
        });
    },
    cellChanged(cell) {
      if (! cell.getRow().getData().url || ! cell.getRow().getData().tenantId) {
        this.$notify.warn({message: "Need both URL and Tenant ID before row is saved.", timeOut: 5000})
        return
      }
      var payload = { id: cell.getRow().getData().id,
        url: cell.getRow().getData().url,
        tenantId: cell.getRow().getData().tenantId }

      this.$store.dispatch("setExecuting", true)
      api.post("/admin/tenantRedirectors", payload).then(
        (details) => {
          cell.getRow().getCell("tenantName").setValue(details.data.tenantName)
          this.$notify.success({message: "Saved", timeOut: 2000})
        },
        (error) => {
          cell.restoreOldValue()
          this.$notify.error({message: error.response.data, timeOut: 8000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })





    }

  }

}
;
</script>

<style lang="scss">
@import 'tabulator-tables';
</style>
